import AgendaPage from '../../agenda/pages/AgendaPage';
import Appointments from '../../appointments/Appointments';
import CmsPage from '../../cms/CmsPage';
import RdvOffersScreen from '../../components/rdv/RdvOffersScreen';
import RdvScreen from '../../components/rdv/RdvScreen';
import DataPage from '../../core-data/DataPage';
import ExhibitorPage from '../../exhibitors/pages/ExhibitorPage';
import ExhibitorsPage from '../../exhibitors/pages/ExhibitorsPage';
import TabbedExhibitorPage from '../../exhibitors/pages/TabbedExhibitorPage';
import { LeaderboardPage } from '../../gamification/leaderboard/screens/LeaderboardPage';
import HomeVideo3DX from '../../home/pages/HomeVideo3DX';
import SplashScreen from '../../home/pages/SplashScreen/SplashScreen';
import IframePage from '../../iframe/IframePage';
import MementoIframePage from '../../iframe/partners/MementoIframePage';
import NetworkingRouter from '../../networking/NetworkingRouter';
import NotificationsScreen from '../../notifications/NotificationsScreen';
import ParticipantsScreen from '../../participants/ParticipantsScreen';
import PlanPage from '../../plan/PlanPage';
import { ProfileScreen } from '../../profile/Profile';
import ProfilePage from '../../profile/pages/ProfilePage';
import ProfilePageV2 from '../../profile/v2/ProfilePageV2';
import { SocialWallV2 } from '../../social-wall-v2/SocialWallV2';
import Speaker from '../../speakers/Speaker';
import SpeakersPage from '../../speakers/pages/SpeakersPage';
import WorkshopSessionPage from '../../workshop-session/pages/WorkshopSessionPage';
import WorkshopLive from '../../workshops/WorkshopLive';
import SessionPage from '../../workshops/pages/SessionPage';
import WorkshopPage from '../../workshops/pages/WorkshopPage';
import WorkshopSessionsPage from '../../workshops/pages/WorkshopSessionsPage';
import WorkshopsPage from '../../workshops/pages/WorkshopsPage';

export const routeComponents = {
  'agenda': AgendaPage,
  'appointments': Appointments,
  'cms': CmsPage,
  'cv-profile': ProfilePage,
  'data': DataPage,
  'exhibitor': ExhibitorPage,
  'exhibitor-group': RdvScreen,
  'exhibitor-tabbed': TabbedExhibitorPage,
  'exhibitors': ExhibitorsPage,
  'home-video-3dx': HomeVideo3DX,
  'iframe': IframePage,
  'matching': RdvOffersScreen,
  'notifications': NotificationsScreen,
  'participants': ParticipantsScreen,
  'partner-memento': MementoIframePage,
  'plan': PlanPage,
  'profile': ProfileScreen,
  'session-page': SessionPage,
  'speaker': Speaker,
  'speakers': SpeakersPage,
  'splash-screen': SplashScreen,
  'workshop-live': WorkshopLive,
  'workshop-page': WorkshopPage,
  'workshop-session': WorkshopSessionPage, // Apec
  'workshop-sessions': WorkshopSessionsPage,
  'workshops': WorkshopsPage,
  'leaderboard': LeaderboardPage,
  'social-wall-v2': SocialWallV2,
  'profile-v2': ProfilePageV2,
};

export const componentRouters = {
  networking: NetworkingRouter,
};
